import React, { Component } from "react";
import Slider from "react-slick";

export default class LogoSlider extends Component {
    render() {
        var settings = {
            dots: false,
            speed: 1000,
            slidesToShow: 6,
            slidesToScroll: 6,
            initialSlide: 0,
            autoplay: true,
            autoplaySpeed: 1000,
            infinite: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5,
                        initialSlide: 5
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
            ]
        };

        const logos = [
            { url: "https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/visual-studio-code/visual-studio-code.png" },
            { url: "https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/html/html.png" },
            { url: "https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/css/css.png" },
            { url: "https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/javascript/javascript.png" },
            { url: "https://camo.githubusercontent.com/2b7784939999f42d7416c795b7289f1af8ed15684310b424b9083e5bbb90fc75/68747470733a2f2f692e696d6775722e636f6d2f30414e467a32312e706e67" },
            { url: "https://camo.githubusercontent.com/39ec32f470b520d99d99a951e70c33d99c87ac211b44c6b83671e6571b45a0b0/68747470733a2f2f692e696d6775722e636f6d2f5676686b4253732e706e67" },
            { url: "https://camo.githubusercontent.com/6a3b37dc03a5de4c6ed4bce65563cf30753849215d426d4898312f992eec8f84/68747470733a2f2f692e696d6775722e636f6d2f4275496974556c2e706e67" },
            { url: "https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/nodejs/nodejs.png" },
            // { url: "https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/nodejs/nodejs.png" },
            { url: "https://camo.githubusercontent.com/bc74833bcd0871461e8019a56c07d0aa12ab3ad9f8562c223761b4cf7949d8ce/68747470733a2f2f6d69726f2e6d656469756d2e636f6d2f6d61782f3735302f312a5430612d51554e65775a4473797836426b696e6665772e706e67" },
            { url: "https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/git/git.png" },
            { url: "https://camo.githubusercontent.com/df1439c289b9cb4558e079a9110731e666976c4f2b6ef387b8fee78ca95375dc/68747470733a2f2f696d672e69636f6e73382e636f6d2f636f6c6f722f3435322f66697265626173652e706e67" },
            { url: "https://camo.githubusercontent.com/342abf2b9b6dae7f62e3301e35ff4998eac76e174a5919f4fbea8198edef6eaa/68747470733a2f2f692e696d6775722e636f6d2f516370516a63642e706e67" },
            { url: "https://raw.githubusercontent.com/github/explore/78df643247d429f6cc873026c0622819ad797942/topics/github/github.png" },
            { url: "https://camo.githubusercontent.com/438522ac26bb05c47b5a243f914d2dab7c49265b6ee09bbc7df43004f96754f6/68747470733a2f2f6432656970397366336f6f3663322e636c6f756466726f6e742e6e65742f746167732f696d616765732f3030302f3030302f3335392f66756c6c2f657870726573736a736c6f676f2e706e67" },
            { url: "https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/terminal/terminal.png" },
            { url: "https://camo.githubusercontent.com/cadb87a766cb9589fd50f856e8db070acde634e22c534da66fe0e3ecdabfde25/68747470733a2f2f75706c6f6164732e73697465706f696e742e636f6d2f77702d636f6e74656e742f75706c6f6164732f323031362f30342f313436313132323338376865726f6b752d6c6f676f2e6a7067" },
            { url: "https://camo.githubusercontent.com/d095bd77367710148b040f2385dd1ebe6830960238fb9f774880f7e059199fa1/68747470733a2f2f6d656469612d657870312e6c6963646e2e636f6d2f646d732f696d6167652f43344530424151454174372d7536474a4d6c772f636f6d70616e792d6c6f676f5f3230305f3230302f303f653d3231353930323434303026763d6265746126743d344359786c3761745a30596e396c4a6b6f36773032794979775951694c7239687251634833634634474449" },

        ]
        return (
            <div>
                <Slider {...settings}>
                    {logos.map((logo, i) => (
                        <div key={i} className="px-5">
                            <img className="object-contain rounded-2xl" src={logo.url} alt="" />
                        </div>
                    ))}
                </Slider>
            </div>
        );
    }
}